/* eslint-disable @typescript-eslint/no-explicit-any */
import request from "@/request/index";

const ACCOUNT_LOGIN = '/api/account/login';
const USER_INFO = '/api/user/info';
const VERIFY_CODE_LOGIN = '/api/account/verify-code-login';
const VERIFY_CODE = '/api/account/verify-code';
const ACCOUNT_RESETPWD = '/api/account/reset-pwd'

export const postAccountResetPwd = (param: any) => {
    return new Promise((resolve, reject) => {
        request({
            url: ACCOUNT_RESETPWD,
            method: 'post',
            data: param,
            headers: {
                
            },
        }).then((res) => {
            return resolve(res)
        }).catch((err) => {
            return reject(err);
        })
    })
};

export const postVerifyCode = (param: any) => {
    return new Promise((resolve, reject) => {
        request({
            url: VERIFY_CODE,
            method: 'post',
            data: param,
            headers: {
                
            },
        }).then((res) => {
            return resolve(res)
        }).catch((err) => {
            return reject(err);
        })
    })
};

export const postVerifyCodeLogin = (param: any) => {
    return new Promise((resolve, reject) => {
        request({
            url: VERIFY_CODE_LOGIN,
            method: 'post',
            data: param,
            headers: {
                
            },
        }).then((res) => {
            return resolve(res)
        }).catch((err) => {
            return reject(err);
        })
    })
};

export const postAccountLogin = (param: any) => {
    return new Promise((resolve, reject) => {
        request({
            url: ACCOUNT_LOGIN,
            method: 'post',
            data: param,
            headers: {
                
            },
        }).then((res) => {
            return resolve(res)
        }).catch((err) => {
            return reject(err);
        })
    })
};

export const getUserInfo = (param: any) => {
    return new Promise((resolve, reject) => {
        request({
            url: USER_INFO,
            method: 'get',
            data: param,
            headers: {
                
            },
        }).then((res) => {
            return resolve(res)
        }).catch((err) => {
            return reject(err);
        })
    })
};

export const postCompanyIdentity = (param: any) => {
    return new Promise((resolve, reject) => {
        request({
            url: '/api/account/choose-company-identity',
            method: 'post',
            data: param,
            headers: {
                
            },
        }).then((res) => {
            return resolve(res)
        }).catch((err) => {
            return reject(err);
        })
    })
};